// M004-F0751 (WebUI #194, T-M004-0312). Download the STORED PDF of one credit note (Spec credit_note.pdf: pdf_base64, pdf_sha256, filename).
// Same rule as the Invoices tab (invoicePdf.js, M004-F0749): the bytes are verified by pdfBlobFromContract, the one checksum path, and
// only then saved under the server filename. A mismatch throws with its code and nothing is offered. The client never re-renders the PDF.
import { creditNoteApi } from '../../services/creditNoteApi';

// Decode the base64 PDF and verify it against the contract's pdf_sha256 BEFORE any file is offered. Fail closed: a mismatch, or a
// browser context that cannot compute SHA-256 (crypto.subtle is absent on plain-http origins), refuses the download. The error text
// leads with the code so the operator can report it (M004-F0751 T-M004-0312, shared with the Invoices tab).
export const PDF_CHECKSUM_MISMATCH = 'PDF_CHECKSUM_MISMATCH';
export const PDF_CHECKSUM_UNAVAILABLE = 'PDF_CHECKSUM_UNAVAILABLE';
export async function pdfBlobFromContract(data) {
  const binary = atob(data.pdf_base64);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  if (!globalThis.crypto?.subtle) {
    throw new Error(`${PDF_CHECKSUM_UNAVAILABLE}: This page cannot verify the PDF checksum (a secure origin is required), so it was not downloaded.`);
  }
  const digest = new Uint8Array(await globalThis.crypto.subtle.digest('SHA-256', bytes));
  const hex = Array.from(digest, (byte) => byte.toString(16).padStart(2, '0')).join('');
  if (hex !== data.pdf_sha256) {
    throw new Error(`${PDF_CHECKSUM_MISMATCH}: The PDF did not match its checksum, so it was not downloaded.`);
  }
  return new Blob([bytes], { type: 'application/pdf' });
}

export async function downloadCreditNotePdf(orgId, row) {
  const response = await creditNoteApi.pdf(orgId, row.credit_note_id);
  const data = response?.data?.data;
  if (!data?.pdf_base64) throw new Error('The Ledger sent no document for this credit note.');
  const url = URL.createObjectURL(await pdfBlobFromContract(data));
  const link = document.createElement('a');
  link.href = url;
  link.download = data.filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
